import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['scroll'];
    static values = {
        class: { type: String, default: 'can-scroll' }
    }

    scrollTargetConnected(target) {
        const checkScrollPos = (function checkScrollPos(target, element, toggleClass) {
            if (target.scrollTop >= (target.scrollHeight - target.offsetHeight - 2)) {
                element.classList.remove(toggleClass);
            } else {
                element.classList.add(toggleClass);
            }

            return checkScrollPos;
        })(target, this.element, this.classValue);

        target.addEventListener('scroll', () => { checkScrollPos(target, this.element, this.classValue) });
        window.addEventListener('resize', target.windowResizeListener = () => { checkScrollPos(target, this.element, this.classValue) });
    }

    scrollTargetDisconnected(target) {
        window.removeEventListener('resize', target.windowResizeListener);
    }
}
